import { Controller } from "@hotwired/stimulus"

// Handles auto-submit of upload destinations form when checkboxes change
export default class extends Controller {
  submit(event) {
    // Submit the form automatically when any checkbox changes
    this.element.requestSubmit()
  }
}
